import { useState, useEffect } from 'react';

/**
 * レスポンシブデザイン用カスタムフック
 * 画面幅に基づいてモバイルデバイスかどうかを判定
 * @param breakpoint ブレークポイント（デフォルト: 768px）
 * @returns isMobile モバイルデバイスかどうか
 */
export const useIsMobile = (breakpoint: number = 768): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
};

